export default "__VITE_ASSET__D8y_UGAQ__"